import React from "react";
import { FaqMain, FaqSection, FaqWrapper } from "../components/Faq/Faq.styled";

export const TermsOfServicePage = () => {
  return (
    <FaqWrapper>
      <div className='container'>
        <FaqMain>
          <h2>Tontake Terms of Service</h2>
          <span>June 1, 2022</span>
          <FaqSection>
            <p>
              <strong>
                By using our service, you agree to be bound by these terms. If you do not agree to these terms, you may not access or use the service.
              </strong>
            </p>

            <p>
              You bear full responsibility for verifying the identity, legitimacy, and authenticity of NFTs that you purchase from third-party sellers
              using the service and we make no claims about the identity, legitimacy, functionality, or authenticity of users or NFTs (and any content
              associated with such NFTs) visible on the service.
            </p>

            <p>
              You are solely responsible for your Account and any associated wallet, and we are not liable for any acts or omissions by you in
              connection with your Account or as a result of your Account or wallet being compromised. You agree to immediately notify us if you
              discover or otherwise suspect any security issues related to the service or your Account.
            </p>

            <p>
              You are solely responsible for ensuring that your access and use of the service in such country, territory or jurisdiction does not
              violate any applicable laws.
            </p>

            <p>
              Disintar’s name, logo, trademarks, and any Disintar product or service names, designs, logos, and slogans are the intellectual property
              of Disintar and may not be copied, imitated or used, in whole or in part, without our prior written permission in each instance.
            </p>

            <p>
              You agree not to infringe or violate the intellectual property rights or any other rights of others; Create or display illegal content,
              such as content that may involve child sexual exploitation; Create or display NFTs that promote suicide or self-harm, incites hate or
              violence against others; Create or display policy-related NFTs.
            </p>

            <p>
              Our site can be used as a tool to NFT mint. After the mint, the image will appear on your profile, visible only to you. It will also
              come to moderation.
            </p>

            <p>
              The value of an NFTs is subjective. Prices of NFTs are subject to volatility and fluctuations in the price of cryptocurrency can also
              materially and adversely affect NFT prices. You acknowledge that you fully understand this subjectivity and volatility and that you may
              lose money.
            </p>
          </FaqSection>
        </FaqMain>
      </div>
    </FaqWrapper>
  );
};
